(() => {
  const PROVINCE_NAMES = {
    서울: '서울특별시',
    부산: '부산광역시',
    대구: '대구광역시',
    인천: '인천광역시',
    광주: '광주광역시',
    대전: '대전광역시',
    울산: '울산광역시',
    세종: '세종특별자치시',
    경기: '경기도',
    강원: '강원특별자치도',
    충북: '충청북도',
    충남: '충청남도',
    전북: '전북특별자치도',
    전남: '전라남도',
    경북: '경상북도',
    경남: '경상남도',
    제주: '제주특별자치도'
  };

  let saveTimer;

  function getFields(container) {
    return {
      postcode: container.querySelector('[data-kakao-postcode]'),
      address1: container.querySelector('[data-kakao-address1]'),
      address2: container.querySelector('[data-kakao-address2]'),
      status: container.querySelector('[data-kakao-status]'),

      cartPostcode: container.querySelector('[data-cart-postcode]'),
      cartAddress1: container.querySelector('[data-cart-address1]'),
      cartAddress2: container.querySelector('[data-cart-address2]'),
      cartProvince: container.querySelector('[data-cart-province]'),
      cartCity: container.querySelector('[data-cart-city]'),

      checkoutPostcode: container.querySelector('[data-checkout-postcode]'),
      checkoutAddress1: container.querySelector('[data-checkout-address1]'),
      checkoutAddress2: container.querySelector('[data-checkout-address2]'),
      checkoutProvince: container.querySelector('[data-checkout-province]'),
      checkoutCity: container.querySelector('[data-checkout-city]')
    };
  }

  function setStatus(fields, message, isError = false) {
    if (!fields.status) return;

    fields.status.textContent = message;
    fields.status.classList.toggle('is-error', isError);
  }

  function syncFields(fields) {
    const postcode = fields.postcode.value.trim();
    const address1 = fields.address1.value.trim();
    const address2 = fields.address2.value.trim();

    fields.cartPostcode.value = postcode;
    fields.cartAddress1.value = address1;
    fields.cartAddress2.value = address2;

    fields.checkoutPostcode.value = postcode;
    fields.checkoutAddress1.value = address1;
    fields.checkoutAddress2.value = address2;
  }

  async function saveAddress(container) {
    const fields = getFields(container);
    syncFields(fields);

    const root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          '배송지 우편번호': fields.cartPostcode.value,
          '배송지 기본주소': fields.cartAddress1.value,
          '배송지 상세주소': fields.cartAddress2.value,
          '배송지 시도': fields.cartProvince.value,
          '배송지 시군구': fields.cartCity.value
        }
      })
    });

    if (!response.ok) {
      throw new Error('주소를 저장하지 못했습니다.');
    }
  }

  function openPostcode(container) {
    const fields = getFields(container);

    if (!window.kakao || !window.kakao.Postcode) {
      setStatus(
        fields,
        '주소 검색 서비스를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
        true
      );
      return;
    }

    new window.kakao.Postcode({
      oncomplete(data) {
        const selectedAddress =
          data.roadAddress ||
          data.autoRoadAddress ||
          data.address ||
          data.jibunAddress;

        const province =
          PROVINCE_NAMES[data.sido] || data.sido || '';

        fields.postcode.value = data.zonecode || '';
       let streetAddress = selectedAddress || '';

[data.sido, data.sigungu].forEach((regionName) => {
  if (
    regionName &&
    streetAddress.startsWith(regionName)
  ) {
    streetAddress = streetAddress
      .slice(regionName.length)
      .trim();
  }
});

fields.address1.value = streetAddress;

        fields.cartProvince.value = province;
        fields.cartCity.value = data.sigungu || '';
        fields.checkoutProvince.value = province;
        fields.checkoutCity.value = data.sigungu || '';

        syncFields(fields);
        setStatus(fields, '주소가 선택되었습니다. 상세주소를 확인해 주세요.');

        saveAddress(container)
          .then(() => {
            setStatus(fields, '배송지 주소가 저장되었습니다.');
          })
          .catch(() => {
            setStatus(
              fields,
              '주소는 선택되었지만 저장하지 못했습니다. 다시 시도해 주세요.',
              true
            );
          });

        fields.address2.focus();
      }
    }).open();
  }

  document.addEventListener('click', (event) => {
    const searchButton = event.target.closest('[data-kakao-search]');
    if (!searchButton) return;

    const container = searchButton.closest('[data-kakao-address]');
    if (!container) return;

    openPostcode(container);
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-kakao-address2]')) return;

    const container = event.target.closest('[data-kakao-address]');
    if (!container) return;

    const fields = getFields(container);
    syncFields(fields);

    clearTimeout(saveTimer);

    saveTimer = setTimeout(() => {
      saveAddress(container).catch(() => {
        setStatus(
          fields,
          '상세주소를 저장하지 못했습니다. 다시 입력해 주세요.',
          true
        );
      });
    }, 700);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      const container =
  form.querySelector('[data-kakao-address]') ||
  document.querySelector('[data-address-context="main"]');
      if (!container) return;

      const submitter = event.submitter;
      const isCheckout =
        submitter &&
        (submitter.name === 'checkout' ||
          submitter.matches('[name="checkout"]'));

      if (!isCheckout) return;

      const fields = getFields(container);
      syncFields(fields);
if (container.dataset.addressContext === 'main') {
  const checkoutValues = [
    ['checkout[shipping_address][country]', 'South Korea'],
    ['checkout[shipping_address][zip]', fields.postcode.value.trim()],
    ['checkout[shipping_address][address1]', fields.address1.value.trim()],
    ['checkout[shipping_address][address2]', fields.address2.value.trim()],
    ['checkout[shipping_address][province]', fields.cartProvince.value],
    ['checkout[shipping_address][city]', fields.cartCity.value]
  ];

  checkoutValues.forEach(([name, value], index) => {
    let input = form.querySelector(
      `[data-kakao-main-field="${index}"]`
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.dataset.kakaoMainField = index;
      form.appendChild(input);
    }

    input.name = name;
    input.value = value;
  });
}
      if (
        !fields.postcode.value.trim() ||
        !fields.address1.value.trim()
      ) {
        event.preventDefault();

        setStatus(
          fields,
          '주소를 먼저 검색하면 결제 시 배송 정보가 자동으로 입력됩니다.',
          true
        );

        container.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    true
  );
  document.addEventListener(
  'click',
  async (event) => {
    const checkoutButton = event.target.closest(
      'button[name="checkout"][form="cart"]'
    );

    if (!checkoutButton) return;

    const container = document.querySelector(
      '[data-address-context="main"]'
    );

    if (!container) return;

    const fields = getFields(container);
    syncFields(fields);

    if (
      !fields.postcode.value.trim() ||
      !fields.address1.value.trim()
    ) {
      event.preventDefault();

      setStatus(
        fields,
        '주소를 먼저 검색하면 결제 시 배송 정보가 자동으로 입력됩니다.',
        true
      );

      container.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return;
    }

    event.preventDefault();
    checkoutButton.disabled = true;

    setStatus(fields, '체크아웃으로 이동하고 있습니다.');

    try {
      await saveAddress(container);

      const root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(`${root}cart.js`, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('장바구니를 불러오지 못했습니다.');
      }

      const cart = await response.json();

      const hasSellingPlan = cart.items.some(
        (item) => item.selling_plan_allocation
      );

      if (hasSellingPlan) {
        throw new Error(
          '정기구독 상품은 주소 자동 입력을 사용할 수 없습니다.'
        );
      }

      const variantParams = cart.items
        .map((item) => `${item.variant_id}:${item.quantity}`)
        .join(',');

      if (!variantParams) {
        throw new Error('장바구니가 비어 있습니다.');
      }

      const params = new URLSearchParams();

      params.set(
        'checkout[shipping_address][country]',
        'KR'
      );
      params.set(
        'checkout[shipping_address][zip]',
        fields.postcode.value.trim()
      );
      params.set(
        'checkout[shipping_address][province]',
        fields.cartProvince.value
      );
      params.set(
        'checkout[shipping_address][city]',
        fields.cartCity.value
      );
      params.set(
        'checkout[shipping_address][address1]',
        fields.address1.value.trim()
      );
      params.set(
        'checkout[shipping_address][address2]',
        fields.address2.value.trim()
      );

      params.set(
        'attributes[배송지 우편번호]',
        fields.postcode.value.trim()
      );
      params.set(
        'attributes[배송지 기본주소]',
        fields.address1.value.trim()
      );
      params.set(
        'attributes[배송지 상세주소]',
        fields.address2.value.trim()
      );

      if (
        Array.isArray(cart.discount_codes) &&
        cart.discount_codes.length
      ) {
        const discountCodes = cart.discount_codes
          .map((discount) => discount.code)
          .filter(Boolean)
          .join(',');

        if (discountCodes) {
          params.set('discount', discountCodes);
        }
      }

      window.location.href =
        `${root}cart/${variantParams}?${params.toString()}`;
    } catch (error) {
      checkoutButton.disabled = false;

      setStatus(
        fields,
        error.message ||
          '체크아웃으로 이동하지 못했습니다. 다시 시도해 주세요.',
        true
      );
    }
  },
  true
);
})();